module.exports = __webpack_public_path__ + "media/images/hitfun/sample.orgquiz-5453c86ad36190d3f8eca4fba4df4ad5.jpg";